import React, {Fragment} from "react";
import {ListPaymentsResponse, Payment, PaymentResult, PaymentStatus, User} from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {Link, RouteComponentProps, withRouter} from "react-router-dom";
import {LoadingViewState, RouterView} from "../RouterView";
import {PaymentService} from "../../services/PaymentService";
import {ConfirmModal} from "../../util/ConfirmModal";
import {DataModal} from "../../util/DataModal";
import {FormGroup} from "react-bootstrap";
import {formatDate} from "../../util/date";
import {UserService} from "../../services/UserService";
import {LoadingSpinner} from "../../util/LoadingSpinner";
import {AdminNotes} from "../notes/AdminNotes";
import PaymentEdit from "./PaymentEdit";
import { PaymentEntriesList } from "./PaymentEntriesList";
import { WalletService } from "../../services/WalletService";


interface State extends LoadingViewState {
    payment? : Payment;
    userPaymentList?: ListPaymentsResponse;
    userInfo?: User;
    logData? : string;
    showActions? : boolean;
    showResolveRefundDialog? : boolean;
    showResolveNoRefundDialog? : boolean;
    showApproveDialog? : boolean;
    showCancelDialog? : boolean;
    showFailDialog? : boolean;
    showFailApproveDialog? : boolean;
    validationMap? : any;
    paymentTemp? : Payment;
}

interface Props extends RouteComponentProps{ 
    params: {id: string}
}

export class PaymentView extends RouterView<Props, State>{

    paymentService: PaymentService;
    userService: UserService;
    walletService : WalletService;

    constructor(props : Props) {
        super(props);
        this.paymentService = getContainer().getPaymentService();
        this.userService = getContainer().getUserService();
        this.walletService = getContainer().getWalletService();
        this.state = { payment: {}, paymentTemp:{}, logData : "", showActions: false, showApproveDialog: false, showCancelDialog: false,
        showFailDialog: false, showFailApproveDialog: false, showResolveNoRefundDialog: false, showResolveRefundDialog: false};
    }

    loadContent(e?:any, method?:string) : Promise<any> | void {
        let id = (this.props.match.params as any).id;
        this.setState({paymentTemp:this.state.payment})
        if(id!=="undefined" && id!=="new"){
            this.refreshPayments(id);
            if(method==="CANCEL"){
                this.paymentService.getEntity(id).then((a : Payment) => {
                    if(a.status!==PaymentStatus.CANCELED.toString()){
                        this.setState({showFailApproveDialog:true, logData: "User does not have enough balance on the wallet"});
                    }
                })
            }
        } 
    }

    componentWillReceiveProps(nextProps: Readonly<Props>, nextContext: any): void {
        let id = nextProps.location.pathname.replace("/payment/","");
        this.refreshPayments(id);
    }

    
    refreshPayments(id:any) {
        let payment: Payment;
        this.paymentService.getEntity(id).then((a : Payment) => {
            payment = a;
            let userId = payment.userId ? payment.userId : "";
            let request:any = a !== undefined ? {userId:userId, ascending: false} : {};
            this.userService.getEntity(userId.toString()).then((data=>{
                this.setState({userInfo:data})
            }));
            this.paymentService.list(request).then((data=>{
                this.setState({payment:payment, userPaymentList: data, loading: false, showResolveRefundDialog: false, showResolveNoRefundDialog: false})
            }));
        });
    }

    getTitle(): string {
        let id = (this.props.match.params as any).id;
        let title = "Payment Details";

        if(id==="new"){
            title="";
        }

        return title;
    }

    cancelPayment() {
        if (this.state.payment && this.state.payment.id){
            this.setState({ showCancelDialog: false, loading: true });
            this.paymentService.cancelPayment(this.state.payment.id).then((response) => {
                this.loadContent(response);
            }).catch((e)=>{
                this.loadContent(e,"CANCEL");
            });
        }    
    }

    approvePayment() {
        if (this.state.payment && this.state.payment.id){
            this.setState({ showApproveDialog: false, loading: true });
            this.paymentService.approvePayment(this.state.payment.id).then((response : PaymentResult) => {
                this.loadContent();
                this.setState({showFailApproveDialog:true, logData: response.message});
            }).catch(error=>{
                this.setState({showFailApproveDialog:true, logData: error.message});
            });          
        }
    }

    failPayment() {
        if (this.state.payment && this.state.payment.id){
            this.setState({ showFailDialog: false, loading: true });
            this.paymentService.failPayment(this.state.payment.id).then((response) => {
                this.loadContent();
            });
        }
    }

    resolvePayment(refund: boolean) {
        if (this.state.payment && this.state.payment.id){
            if (refund) {
                this.setState({ showResolveRefundDialog: true, loading: true });
            } else {
                this.setState({ showResolveNoRefundDialog: true, loading: true });
            }

            this.paymentService.resolvePayment(this.state.payment.id, refund).then((response) => {
                this.loadContent();
            });
        }
    }

    renderLog() {
        if (this.state.payment && this.state.payment.log){
            let rows = this.state.payment.log.map(p => {
                return (
                    <tr key={p.id}>
                        <td>{p.id}</td>
                        {p.timestamp && (
                            <td>{formatDate(Number(p.timestamp.toString().split(".").join("").substring(0,13)))}</td>
                        )}
                        <td>{p.type}</td>
                        <td>{p.status}</td>
                        <td>{p.error ? "YES" : "NO" }</td>
                        <td>{p.message}</td>
                        <td>{p.data  &&  <button className="btn btn-xs btn-primary" onClick={ () => this.setState({showFailApproveDialog:true,logData: p.data}) }>View Data</button>}</td>
                    </tr>
                );
            });

            return (
                <table className="table m-b-xs table-striped">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Timestamp</th>
                            <th>Event Type</th>
                            <th>Payment Status</th>
                            <th>Is Error</th>
                            <th>Message</th>
                            <th>Data</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows}
                    </tbody>
                </table>
            );
        }
    }

    renderActions() {
        if (this.state.payment) {
            let p = this.state.payment;
            let isDeposit = p.type === "DEPOSIT";

            let canCancel = (!isDeposit  &&  p.status === "INITIATED") || (isDeposit  &&  (p.status === "COMPLETED" || p.status === "PENDING") && p.attributes!==undefined && p.attributes["PAYMENT_METHOD"]==="manual");
            let canApprove = !isDeposit  &&  p.status === "INITIATED";

            return (
                <div> 
                    <FormGroup className="form-group">
                        <div>
                            { canCancel &&  <button className="btn btn-spacing btn-danger" onClick={ () => this.setState({ showCancelDialog: true }) }>Cancel Payment</button>}
                            { canApprove  &&  <button className="btn btn-spacing btn-primary" onClick={ () => this.setState({ showApproveDialog: true }) }>Approve Payment</button> }
                        </div>
                    </FormGroup>
                </div>
            );
        }
    }

    renderUserHistory() {
        let list = this.state.userPaymentList && this.state.userPaymentList.items;
        let firstWithdraw : boolean = false;
        let withdrawCount: number = 0;
        let madeDeposit : boolean = false;
        let kycCompleted : boolean = false;
        let lastTenTransactions : Payment[] = [];
        let rows:any;

        list && list.forEach((item:Payment) => {
            if(item.type === "DEPOSIT") {
                if(item.status === "COMPLETED")
                    madeDeposit = true;
            }
            if(item.type === "WITHDRAWAL") {
                if(item.status === "COMPLETED") {
                    withdrawCount++;
                }
            }
        });

        withdrawCount >= 1 ? firstWithdraw = true : firstWithdraw = false;

        if(this.state.userInfo && this.state.userInfo.kycVerified) {
            kycCompleted = true;
        }
        if(list) {
            let listMaxLength = list.length > 9 ? 9 : list.length;
            lastTenTransactions = list.slice(0,listMaxLength);
            rows = lastTenTransactions.map(p => {
                return (
                    <tr key={p.id}>
                        {p.created && (
                            <td>{formatDate(Number(p.created.toString().split(".").join("").substring(0,13)))}</td>
                        )}
                        <td>{p.type}</td>
                        <td>{p.amount}</td>
                        <td>{p.status}</td>
                    </tr>
                );
            });
        }

        return (
            <div>
                <FormGroup className="form-group">
                    <div>
                        <p>User {this.state.userInfo && this.state.userInfo.id} has done the following: </p>
                        <table className="table table-bordered" style={{"width":"50%"}}>
                            <tbody>
                                {this.state.payment && this.state.payment.type==="WITHDRAWAL" && (this.state.payment.status === "PENDING" || this.state.payment.status === "COMPLETED" || this.state.payment.status === "INITIATED") &&(
                                    <tr style={{"width":"50%"}}>
                                        <td style={{"width":"40%"}}>Previous completed withdraw?</td>
                                        <td style={{"width":"10%"}} className={firstWithdraw ? "table-success": "table-danger"}>{firstWithdraw ? "YES" : "NO"}</td>
                                    </tr>
                                )}
                                <tr>
                                    <td style={{"width":"40%"}}>Previous deposit?</td>
                                    <td style={{"width":"10%"}} className={madeDeposit ? "table-success": "table-danger"}>{madeDeposit ? "YES": "NO"}</td>
                                </tr>
                                <tr>
                                    <td style={{"width":"40%"}}>KYC Completed?</td>
                                    <td style={{"width":"10%"}} className={kycCompleted ? "table-success": "table-danger"}>{kycCompleted ? "YES": "NO"}</td>
                                </tr>
                            </tbody>
                        </table>
                        <p>Last {lastTenTransactions.length} Payments:</p>
                        <table className="table m-b-xs table-striped">
                            <thead>
                            <tr>
                                <th>Timestamp</th>
                                <th>Event Type</th>
                                <th>Amount</th>
                                <th>Payment Status</th>
                            </tr>
                            </thead>
                            <tbody>
                            {rows}
                            </tbody>
                        </table>
                    </div>
                </FormGroup>
            </div>
        );
    }

    renderResolveActions() {
        if (this.state.payment && this.state.payment.status){
            let p = this.state.payment;
            if (p.status !== "FAILED_PERMANENTLY" && p.status !== "FAILED") {
                return <div/>;
            }

            return (
                <div>
                    <FormGroup className="form-group">
                        <div>
                            { <button className="btn btn-spacing btn-danger" onClick={ () => this.setState({ showResolveRefundDialog: true }) }>Resolve and Refund</button>}
                            { <button className="btn btn-spacing btn-danger" onClick={ () => this.setState({ showResolveNoRefundDialog: true }) }>Resolve Only</button>}
                        </div>
                    </FormGroup>
                    <div className="ibox-title">
                        <h5>Manual Resolve</h5>
                    </div>
                    <div className="ibox-content">
                        <p>
                            <strong>NOTE:</strong> Those actions should only be used if the payment is stuck.
                        </p>
                        <p>
                            Use <strong>Resolve and Refund</strong> to mark as manually resolved. The payment will not be retried and reserved funds
                            will be transfered back to the user balance
                        </p>
                        <p>
                            Use <strong>Reslove Only</strong> to just mark the payment as resolved without refunding the player. This should rarely be used.
                        </p>

                    </div>
                </div>
            );
        }
    }


    renderTransactions() {
        return (
        <> 
            <PaymentEntriesList paymentId={(this.props.match.params as any).id} service={this.walletService} />     
        </>
        )
    }

    renderContent() {
        if (!this.state.payment) {
            return <LoadingSpinner/>;
        }

        let p = this.state.payment;
        let amount = `${p.amount} ${p.currency}`; 

        let userLink = p.userId ? <Link to={"/user/" + p.userId}>{p.userId}</Link> : <div>n/a</div>;
        
        let id = (this.props.match.params as any).id;

      
        return (
            <Fragment>
                {id!=="undefined" && id!=="new" && (
                    <div>
                        <ConfirmModal
                            show={this.state.showCancelDialog} 
                            heading="Cancel Payment"
                            description={ `Payment request of ${amount} will be canceled and the player will be refunded.` }
                            okLabel="Cancel Payment"
                            okClassName="btn-danger"
                            onOk={ this.cancelPayment.bind(this) }
                            onCancel={ () => this.setState({ showCancelDialog: false })}
                        />
                        
                        <ConfirmModal
                            show={this.state.showApproveDialog}
                            heading="Approve Payment"
                            description={ `Approve and perform payment of ${amount}` }
                            okLabel="Approve Payment"
                            okClassName="btn-primary"
                            onOk={ this.approvePayment.bind(this) }
                            onCancel={ () => this.setState({ showApproveDialog: false })}
                        />

                        <ConfirmModal
                            show={this.state.showResolveRefundDialog}
                            heading="Resolve and Refund"
                            description={ `Mark as resolved and refund player: ${amount}` }
                            okLabel="Resolve and Refund"
                            okClassName="btn-primary"
                            onOk={ this.resolvePayment.bind(this, true) }
                            onCancel={ () => this.setState({ showResolveRefundDialog: false }) }
                        />
                    
                        <ConfirmModal
                            show={this.state.showResolveNoRefundDialog}
                            heading="Resolve Without Refund"
                            description={ `Mark as resolved but don't refund player. This must be done manually in this case.` }
                            okLabel="Resolve"
                            okClassName="btn-primary"
                            onOk={ this.resolvePayment.bind(this, false) }
                            onCancel={ () => this.setState({ showResolveNoRefundDialog: false }) }
                        />

                        <ConfirmModal
                            show={this.state.showFailApproveDialog}
                            heading="Update result"
                            description={this.state.logData}
                            okLabel="OK"
                            okClassName="btn-primary"
                            onOk={()=>this.setState({showFailApproveDialog: false})}
                            hideCancelButton={true}
                            showCloseButton={false}
                            showDescriptionTextArea={true}
                        />
                        
                        {/* Validation to not lose the previous flow*/
                            this.state.showFailApproveDialog===undefined &&(
                                <DataModal
                                    show={this.state.logData !== ""}
                                    heading="Log Data"
                                    onClose={() => this.setState({ logData: "" }) }
                                    data={this.state.logData}
                                /> 
                            )
                        }
                        
                        
                        {/* <div className="row wrapper border-bottom white-bg page-heading">
                            <div className="col-lg-12">
                                <h1>{this.getTitle()}</h1>
                            </div>
                        </div> */}
                        <div className="wrapper wrapper-content animated">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className={"card"}>
                                            <div className="card-header">
                                                <h4>{p.type} <strong>{amount}</strong></h4>
                                            </div>
                                            <div className="card-body">
                                                <div className="ibox-content">
                                                    <table className="table m-b-xs table-striped">
                                                        <tbody>
                                                        <tr><td className="col-md-4"><strong>ID:</strong></td><td className="col-md-8">{p.id}</td></tr>
                                                        <tr>
                                                            <td className="col-md-4"><strong>PSP ID:</strong></td>
                                                            <td className="col-md-8">{p.externalPaymentId}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="col-md-4"><strong>User:</strong></td>
                                                            <td className="col-md-8">{userLink}</td>
                                                        </tr>
                                                        <tr><td className="col-md-4"><strong>Provider:</strong></td><td className="col-md-8">{p.provider}</td></tr>
                                                        <tr><td className="col-md-4"><strong>Amount:</strong></td><td className="col-md-8">{`${p.amount} ${p.currency}`}</td></tr>
                                                        {p.fee === undefined && (
                                                            <tr><td className="col-md-4"><strong>Fee:</strong></td><td className="col-md-8">{`${0} ${p.currency}`}</td></tr>
                                                        )}
                                                        {p.fee && (
                                                            <tr><td className="col-md-4"><strong>Fee:</strong></td><td className="col-md-8">{`${p.fee} ${p.currency}`}</td></tr>
                                                        )}
                                                        <tr><td className="col-md-4"><strong>UID:</strong></td><td className="col-md-8">{p.uid}</td></tr>
                                                        {p.created && (
                                                            <tr><td className="col-md-4"><strong>Created:</strong></td><td className="col-md-8">{formatDate(Number(p.created.toString().split(".").join("").substring(0,13)))}</td></tr>
                                                        )}
                                                        {p.updated && (
                                                            <tr><td className="col-md-4"><strong>Updated:</strong></td><td className="col-md-8">{formatDate(Number(p.updated.toString().split(".").join("").substring(0,13)))}</td></tr>
                                                        )}
                                                        <tr><td className="col-md-4"><strong>Status:</strong></td><td className="col-md-8">{p.status}</td></tr>
                                                        <tr><td className="col-md-4"><strong>Transaction ID:</strong></td><td className="col-md-8">{p.paymentTxId}</td></tr>
                                                        <tr><td className="col-md-4"><strong>Reverse Transaction ID:</strong></td><td className="col-md-8">{p.paymentReverseTxId}</td></tr>
                                                        <tr><td className="col-md-4"><strong>Attributes:</strong></td><td className="col-md-8"><pre>{JSON.stringify(p.attributes, null, 2)}</pre></td></tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"col-lg-6"}>
                                        <div className={"row"}>
                                            <div className={"col-lg-12"}>
                                                <AdminNotes type={"PAYMENT"} typeId={""+this.state.payment.id} title={"Payment Notes"}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card-box">
                                            <div className="ibox-title">
                                                <h5>Event Log</h5>
                                            </div>
                                            <div className="ibox-content">
                                                {this.renderLog()}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card-box">
                                            <div className="ibox-title">
                                                <h5>Payment Transactions</h5>
                                            </div>
                                            <div className="ibox-content">
                                                {this.renderTransactions()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className={"card"}>
                                        <div className="card-header">
                                            <h4>History</h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="ibox-content">
                                                {this.renderUserHistory()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className={"card"}>
                                        <div className="card-header">
                                            <h4>Actions</h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="ibox-content">
                                                {this.renderActions()}
                                            </div>
                                            {this.renderResolveActions()}
                                        </div>

                                    </div>
                                </div>
                            </div>
                                {/*<div className="row">*/}
                                {/*    <div className="col-lg-12">*/}
                                {/*        <div className="card-box">*/}
                                {/*            <div className="ibox-title">*/}
                                {/*                <h5>Payment Adjustment</h5>*/}
                                {/*            </div>*/}
                                {/*            <div className="ibox-content">*/}
                                {/*                <p>Make a transaction to/from the user with a reference to this payment.</p>*/}
                                {/*            </div>*/}
                                {/*        </div>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                        </div>
                    </div>

                )}
                {id=="new" && (
                    <PaymentEdit/>
                )}
                
            </Fragment>
        )
    }

}

export default withRouter(PaymentView);
